import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import timeInHoursAndMinutes from '../../../../utils/timeInHoursAndMinutes';
import '../../renderService.scss';
/**
 * Helper method to highlight matched words in a search with bold. Used by RenderService which is supplied to react-select-search as "option"
 * Taken from the basic usage in markSearch.js
 */
function checkMatch(service, input) {
    const regex = input && new RegExp(input.search.trim(), 'i');
    const segments = service.name.split(regex);
    const match = service.name.match(regex);
    if (input && input.search) {
        if (match) {
            return (_jsxs("div", { className: "service_name", children: [segments[0], _jsx("span", { className: "searched", children: match }), segments[1]] }));
        }
        return _jsx("div", { className: "service_name", children: service.name });
    }
    return _jsx("div", { className: "service_name", children: service.name });
}
const RenderService = (service, input) => {
    const { hours, minutes } = timeInHoursAndMinutes(service.timeUnitPerService);
    const serviceName = checkMatch(service, input);
    return (_jsxs("div", { className: "service_outer", children: [serviceName, _jsx("div", { className: "service_time", children: `${hours}t ${minutes}m` }), _jsx("div", { className: "service_price", children: `${service.amount}-,` })] }));
};
export default RenderService;
